export const documentEditorZh = {
  placeholder: {
    default: '开始输入...',
  },
  toolbar: {
    placeholder: '工具栏',
  },
  wordCount: {
    characters: '{count} 字符',
    words: '{count} 词',
    paragraphs: '{count} 段落',
  },
  actions: {
    undo: '撤销 (⌘Z)',
    redo: '重做 (⌘⇧Z)',
    heading1: '标题 1',
    heading2: '标题 2',
    heading3: '标题 3',
    bold: '粗体 (⌘B)',
    italic: '斜体 (⌘I)',
    underline: '下划线 (⌘U)',
    strike: '删除线 (⌘⇧S)',
    code: '代码 (⌘E)',
    highlight: '高亮 (⌘⇧H)',
    link: '链接 (⌘K)',
    bulletList: '无序列表',
    orderedList: '有序列表',
    blockquote: '引用块',
    horizontalRule: '分割线',
  },
  slashMenu: {
    noResults: '没有找到匹配的命令',
    items: {
      paragraph: {
        title: '正文',
        description: '普通段落文本',
      },
      heading1: {
        title: '标题 1',
        description: '最大的标题',
      },
      heading2: {
        title: '标题 2',
        description: '中等大小的标题',
      },
      heading3: {
        title: '标题 3',
        description: '小标题',
      },
      heading4: {
        title: '标题 4',
        description: '四级标题',
      },
      bulletList: {
        title: '无序列表',
        description: '创建一个无序列表',
      },
      orderedList: {
        title: '有序列表',
        description: '创建一个有序列表',
      },
      blockquote: {
        title: '引用',
        description: '引用文本块',
      },
      codeBlock: {
        title: '代码块',
        description: '插入代码块',
      },
      divider: {
        title: '分割线',
        description: '插入水平分割线',
      },
      image: {
        title: '图片',
        description: '插入图片',
      },
      table: {
        title: '表格',
        description: '插入表格',
      },
      calloutInfo: {
        title: '信息提示',
        description: '插入信息提示框',
      },
      calloutWarning: {
        title: '警告提示',
        description: '插入警告提示框',
      },
      calloutSuccess: {
        title: '成功提示',
        description: '插入成功提示框',
      },
      calloutError: {
        title: '错误提示',
        description: '插入错误提示框',
      },
    },
  },
  linkEditor: {
    urlLabel: '链接地址',
    urlPlaceholder: '输入或粘贴链接...',
    textLabel: '显示文本',
    textPlaceholder: '链接显示的文字...',
    open: '打开',
    remove: '移除',
    cancel: '取消',
    confirm: '确定',
  },
  imageUploader: {
    dropHint: '点击或拖拽图片到此处上传',
    supportHint: '支持 {types} (最大 {max}MB)',
    selectImage: '选择图片',
    previewAlt: '预览',
    typesSeparator: '、',
    errors: {
      unsupportedType: '不支持的文件类型: {type}',
      maxSizeExceeded: '文件大小超出限制 (最大 {max}MB)',
      uploadFailed: '上传失败',
    },
  },
};
